import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody, Button, Spinner, Badge } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next"
import { map, range } from "lodash"

import ToolkitProvider from "react-bootstrap-table2-toolkit"

//actions

import "../../assets/scss/datatables.scss"
import { defaultImg } from "assets/images"

import MyPagination from "components/Common/MyPagination"
import DeleteModal from "components/Common/DeleteModal"
import { AvField, AvForm } from "availity-reactstrap-validation"
import moment from "moment"
import BannerModal from "./Crud/Modal"
import { deleteBanner, getBanners } from "store/actions"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import { useRole, ROLE_TYPES } from "hooks/useRole"

const Banners = () => {
  const { isAnyRole } = useRole()
  const dispatch = useDispatch()
  const history = useHistory()
  const [page, setPage] = useState(1)
  const [bannerModal, setBannerModal] = useState({ status: false, data: {} })
  const [totalItemLimit, setTotalItemLimit] = useState(() => {
    return parseInt(localStorage.getItem("bannerLimit")) || 10
  })
  const [sort, setSort] = useState("all")

  const { loading, banners, bannerCounts } = useSelector(state => ({
    loading: state.Banner.loading,
    banners: state?.Banner?.banners,
    bannerCounts: state.Banner.banners?.bannerCounts,
  }))

  const totalPages = Math.ceil(banners?.total / totalItemLimit)
  const pages = range(1, totalPages + 1)

  useEffect(() => {
    dispatch(getBanners(page, sort, totalItemLimit))
  }, [dispatch, page, sort, totalItemLimit])

  const [isOpen, setIsOpen] = useState({ status: false, id: "" })

  const handleDelete = id => {
    setIsOpen({ status: true, id: id })
  }

  const handleDeleteEvent = () => {
    setIsOpen({ ...isOpen, status: false })
    dispatch(deleteBanner(isOpen?.id))
  }

  const columns = [
    {
      dataField: "no",
      text: "#",
      sort: true,
    },
    {
      dataField: "createdAt",
      text: "Created At",
    },
    {
      dataField: "priority",
      text: "Priority",
    },
    {
      dataField: "webImage",
      text: "Web Image",
      sort: true,
    },
    {
      dataField: "appImage",
      text: "App Image",
      sort: true,
    },
    {
      dataField: "bannerType",
      text: "Type",
      sort: true,
    },
    {
      dataField: "action",
      text: "Action",
    },
  ]

  const handleColumns = () => {
    if (isAnyRole([ROLE_TYPES.SALES_MANAGER])) {
      return columns?.filter(i => i.dataField !== "action")
    } else return columns
  }
  const getCompressedWebImage = url => {
    if (!url) return defaultImg
    return url.replace("/upload/", "/upload/f_auto,c_fill,w_150,h_70,q_50/")
  }
  const getCompressedAppImage = url => {
    if (!url) return defaultImg
    return url.replace("/upload/", "/upload/f_auto,c_fill,w_110,h_150,q_50/")
  }
  const tableData = map(banners?.banners, (item, index) => ({
    ...item,
    no: index + 1,
    priority: <div style={{}}>{item?.priority || "---"}</div>,

    name: (
      <div style={{ whiteSpace: "break-spaces" }}>
        {item?.name?.slice(0, 110)}
        {item?.name?.length > 110 ? "..." : ""}
      </div>
    ),
    bannerType: (
      <Badge
        style={{ textTransform: "capitalize", marginBottom: "7px" }}
        className={
          "px-2 py-2 badge-soft-" +
          (item?.banner_type === "MAIN"
            ? "success"
            : item?.banner_type === "SUB"
            ? "info"
            : "secondary")
        }
      >
        {item?.banner_type === "MAIN"
          ? "Main"
          : item?.banner_type === "SUB"
          ? "Sub"
          : "-"}
      </Badge>
    ),
    appImage: (
      <span>
        <img
          style={{ width: "110px", height: "150px", objectFit: "cover" }}
          src={
            item?.app_images && item?.app_images[0]
              ? getCompressedAppImage(item?.app_images[0]?.url)
              : defaultImg
          }
          alt=""
          className="img-fluid  d-block"
        />
      </span>
    ),
    webImage: (
      <img
        style={{ width: "150px", height: "70px", objectFit: "cover" }}
        src={
          item?.web_images && item?.web_images[0]
            ? getCompressedWebImage(item?.web_images[0]?.url)
            : defaultImg
        }
        alt=""
        className="img-fluid  d-block"
      />
    ),
    createdAt: moment(item.createdAt).format("DD/MM/YYYY - h:mm a"),
    action: (
      <div>
        <Button
          id={`edit${index}`}
          type="button"
          title="Edit Showroom"
          color="white"
          className="ms-1 btn"
          onClick={() => setBannerModal({ status: true, data: item })}
        >
          <i
            className="bx bx-edit-alt "
            style={{ color: "#ffa500", fontSize: "22px" }}
          />
        </Button>
        {isAnyRole([
          ROLE_TYPES.ADMIN,
          ROLE_TYPES.SUPER_ADMIN,
          ROLE_TYPES.GENERAL_MANAGER,
          ROLE_TYPES.MANAGING_DIRECTOR,
        ]) ? (
          <>
            <Button
              id={`Delete${index}`}
              title="Delete Banner"
              type="button"
              color="white"
              className="ms-1 btn "
              onClick={() => {
                handleDelete(item._id)
              }}
            >
              <i
                className="bx bx-trash "
                style={{
                  color: "red",
                  fontSize: "1.3rem",
                }}
              />
            </Button>
          </>
        ) : (
          ""
        )}
      </div>
    ),
  }))

  const handleStatusController = value => {
    switch (true) {
      case isAnyRole([ROLE_TYPES.ADMIN]):
        return value
      case isAnyRole([ROLE_TYPES.GENERAL_MANAGER]):
        return value
      case isAnyRole([ROLE_TYPES.MANAGING_DIRECTOR]):
        return value
      case isAnyRole([ROLE_TYPES.BRANCH_MANAGER]):
        return ""
    }
  }
  const listChange = sortValue => {
    setSort(sortValue)

    if (location?.pathname === "/dashboard") {
      return ""
    } else {
      history?.push({
        pathname: location.pathname,
        search: `p=${page}&s=${sortValue}`,
        state: {
          page: page,
          sort: handleStatusController(sortValue),
        },
      })
    }
  }

  useEffect(() => {
    if (location?.state?.sort) {
      setSort(location?.state?.sort)
    }
  }, [location])
  const handlePageLimit = e => {
    if (e.target.value >= 1) {
      setTotalItemLimit(parseInt(e.target.value))
      localStorage.setItem("bannerLimit", e.target.value)
    }
  }

  const bannerTypeValues = [
    { label: "All", value: "all", count: bannerCounts?.ALL || 0 },
    {
      label: "Main",
      value: "MAIN",
      count: bannerCounts?.MAIN || 0,
    },
    { label: "Sub", value: "SUB", count: bannerCounts?.SUB || 0 },
  ]
  return (
    <React.Fragment>
      <Row>
        <DeleteModal
          show={isOpen?.status}
          onCloseClick={() => setIsOpen({ ...isOpen, status: false })}
          onDeleteClick={handleDeleteEvent}
        />
        {bannerModal?.status && (
          <BannerModal
            onCloseClick={() => setBannerModal({ status: false, data: {} })}
            show={bannerModal?.status}
            updateData={bannerModal?.data}
          />
        )}
        <Col className="col-12">
          <Card>
            <CardBody>
              <ToolkitProvider
                keyField="_id"
                key={"id"}
                columns={handleColumns()}
                data={tableData}
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <div className="d-flex align-items-center justify-content-between p-1">
                      <div>
                        {map(bannerTypeValues, (head, key) => (
                          <>
                            <input
                              type="radio"
                              className="btn-check"
                              name={`btn-radio${key + 1}`}
                              id={head?.value}
                              autoComplete="off"
                              checked={sort === head?.value}
                              onChange={() => listChange(head?.value, key)}
                            />
                            <label
                              className="btn btn-warning "
                              htmlFor={head?.value}
                              style={{
                                borderRadius: 1,
                              }}
                            >
                              {head?.label}
                              <Badge
                                className={`font-size-12 ms-2 ${
                                  sort === head.value
                                    ? "badge-soft-light"
                                    : "badge-soft-light"
                                }`}
                                pill
                              >
                                {head?.count}
                              </Badge>
                            </label>
                          </>
                        ))}
                      </div>
                      <div className="d-flex">
                        <div>
                          <AvForm className="form-horizontal mx-2   d-flex align-items-center ">
                            <div className="mx-1">
                              <span className="">
                                Show
                                <i className="fas fa-sort-numeric-down-alt mx-1"></i>
                              </span>
                            </div>
                            <div className="" style={{ width: "50px" }}>
                              <AvField
                                name="pageLimit"
                                className="form-control"
                                value={totalItemLimit}
                                onChange={e => handlePageLimit(e)}
                                type="text"
                                required
                              />
                            </div>
                          </AvForm>
                        </div>

                        <Button
                          type="button"
                          color="warning"
                          className="btn-rounded  mb-2 me-2 "
                          onClick={() => setBannerModal({ status: true })}
                        >
                          <i className="mdi mdi-plus me-1" />
                          New Banner
                        </Button>
                      </div>
                    </div>

                    {loading ? (
                      <Spinner color="secondary" className="d-block m-auto" />
                    ) : (
                      <>
                        {banners?.total >= 1 ? (
                          <>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField={"id"}
                                    key={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    // selectRow={selectRow}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    // onTableChange={handleTableChange}
                                    // {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>

                            <MyPagination
                              totalPages={pages}
                              page={page}
                              setPage={setPage}
                            />
                          </>
                        ) : (
                          <p className="my-4 mx-3 ">No Banner !</p>
                        )}
                      </>
                    )}
                  </React.Fragment>
                )}
              </ToolkitProvider>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default Banners
